import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MdbTooltipModule } from 'mdb-angular-ui-kit/tooltip';
import { AdminSettingsService } from '../../../../services/admin/admin-settings.service';
import { MdbButtonComponent } from '../../../utils/mdb-button/mdb-button.component';

@Component({
  selector: 'app-admin-settings',
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, MdbTooltipModule, MdbButtonComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './admin-settings.component.html',
})
export class AdminSettingsComponent implements OnInit {
  form = this.fb.group({
    trashmodeDefault: this.fb.control<string | null>(null),
  });
  loading = false;
  errorMessage: string | null = null;

  private readonly destroyRef = inject(DestroyRef);
  private readonly cdr = inject(ChangeDetectorRef);

  constructor(
    private fb: FormBuilder,
    private settingsService: AdminSettingsService,
  ) {}

  ngOnInit(): void {
    this.settingsService.getSettings()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((settings) => {
        this.form.patchValue({
          trashmodeDefault: settings.trashmodeDefault,
        });
        this.cdr.markForCheck();
      });
  }

  save(): void {
    if (this.loading) {
      return;
    }
    this.errorMessage = null;
    this.loading = true;
    this.cdr.markForCheck();
    this.settingsService
      .updateSettings({
        trashmodeDefault: this.form.value.trashmodeDefault ?? null,
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (settings) => {
          this.form.patchValue({
            trashmodeDefault: settings.trashmodeDefault,
          });
          this.loading = false;
          this.cdr.markForCheck();
        },
        error: () => {
          this.loading = false;
          this.errorMessage = 'ADMIN.SETTINGS.SAVE_FAILED';
          this.cdr.markForCheck();
        },
      });
  }
}
